/**
 * Mobil ilova bo'limlari.
 *
 * Har bir bo'lim shu yerda ta'riflanadi: qaysi so'rovdan ma'lumot oladi,
 * ro'yxatda qaysi ustunlar chiqadi, qaysi huquq talab qilinadi. Admin
 * panelidan kelgan sozlama shu ta'rifning ustiga qo'yiladi — ya'ni
 * bo'limni yashirish yoki ustunni olib tashlash uchun kodga tegilmaydi.
 */

export type MobileFieldType =
  | "text"
  | "date"
  | "datetime"
  | "money"
  | "number"
  | "status"
  | "list"

export interface MobileField {
  /** Sozlamada va ustun ro'yxatida ishlatiladigan nom */
  key: string
  /** Tarjima kaliti */
  labelKey: string
  type: MobileFieldType
  /** Yozuvdan qiymatni olish yo'li: "mainCounterparty.name" */
  path: string
  /** Ro'yxatda asosiy ustunmi (u har doim ko'rinadi) */
  primary?: boolean
  /** Standart holatda ko'rinadimi */
  defaultVisible?: boolean
  align?: "left" | "right" | "center"
  /** "list" turi uchun: ichki obyektdagi nom kaliti */
  listNameKey?: string
  /** "list" turi uchun: nom yonida ko'rsatiladigan son kaliti */
  listValueKey?: string
}

export interface MobileSection {
  /** Bo'lim kodi — sozlamada shu bo'yicha saqlanadi */
  code: string
  labelKey: string
  /** Tizimdagi huquq kodi (mainPermission.ResourceName) */
  permission: string
  /** Ma'lumot manbai: REST yo'li */
  url: string
  /** Ro'yxat ustunlari */
  fields: MobileField[]
  /** Jami qatoridagi maydon (totalOutcome ichidan) */
  totalField?: { path: string; labelKey: string; type: MobileFieldType }
  /** Pastki menyuda chiqadimi */
  inTabBar?: boolean
  /** Yangi yozuv qo'shish uchun web sahifasiga yo'l */
  createPath?: string
}

/**
 * Bo'limlar ro'yxati. Tartib pastki menyu va "Yana" sahifasida
 * shu ketma-ketlikda chiqadi.
 */
export const MOBILE_SECTIONS: MobileSection[] = [
  {
    code: "sales",
    labelKey: "sale",
    permission: "sales",
    url: "Sales",
    inTabBar: true,
    createPath: "/sales?sale=add",
    fields: [
      { key: "dateSale", labelKey: "date", type: "datetime", path: "dateSale", primary: true, defaultVisible: true },
      { key: "counterparty", labelKey: "counterparty", type: "text", path: "mainCounterparty.name", primary: true, defaultVisible: true },
      { key: "warehouse", labelKey: "warehouse", type: "text", path: "mainWarehouse.name", defaultVisible: true },
      { key: "product", labelKey: "product", type: "text", path: "mainProduct.nameModel", defaultVisible: false },
      { key: "manager", labelKey: "manager", type: "text", path: "mainManager.name", defaultVisible: false },
      { key: "amount", labelKey: "quantity", type: "number", path: "amount", align: "right", defaultVisible: false },
      { key: "totalPriceUSD", labelKey: "sum", type: "money", path: "totalPriceUSD", align: "right", primary: true, defaultVisible: true },
    ],
    totalField: { path: "totalOutcome.totalPriceUSD", labelKey: "total", type: "money" },
  },
  {
    code: "orders",
    labelKey: "orders",
    permission: "orders",
    url: "Orders",
    inTabBar: true,
    fields: [
      { key: "dateOrder", labelKey: "date", type: "datetime", path: "dateOrder", primary: true, defaultVisible: true },
      { key: "counterparty", labelKey: "counterparty", type: "text", path: "mainCounterparty.name", primary: true, defaultVisible: true },
      { key: "product", labelKey: "product", type: "text", path: "mainProduct.nameModel", defaultVisible: true },
      { key: "amount", labelKey: "quantity", type: "number", path: "amount", align: "right", defaultVisible: true },
      { key: "status", labelKey: "status", type: "status", path: "status", align: "center", defaultVisible: false },
    ],
  },
  {
    code: "wSales",
    labelKey: "wSales",
    permission: "wSales",
    url: "Sales",
    inTabBar: true,
    fields: [
      { key: "dateSale", labelKey: "date", type: "datetime", path: "dateSale", primary: true, defaultVisible: true },
      { key: "counterparty", labelKey: "counterparty", type: "text", path: "mainCounterparty.name", primary: true, defaultVisible: true },
      { key: "amount", labelKey: "quantity", type: "number", path: "amount", align: "right", primary: true, defaultVisible: true },
      { key: "warehouse", labelKey: "warehouse", type: "text", path: "mainWarehouse.name", defaultVisible: false },
    ],
    totalField: { path: "totalOutcome.amount", labelKey: "total", type: "number" },
  },
  {
    code: "residues",
    labelKey: "residues",
    permission: "residues",
    url: "Residues",
    /*
      XATO TUZATILDI: bu yerda "mainProduct.nameModel" va
      "mainWarehouse.name" yozilgan edi, lekin qoldiqlar so'rovi
      boshqacha javob qaytaradi — u jadvallarni birlashtirib, tayyor
      nomlarni beradi. Natijada bo'lim ochilardi-yu, ustunlar BO'SH
      turardi. Endi haqiqiy nomlar ishlatiladi.
    */
    fields: [
      { key: "product", labelKey: "product", type: "text", path: "productName", primary: true, defaultVisible: true },
      { key: "warehouse", labelKey: "warehouse", type: "list", path: "stocks", listNameKey: "warehouseName", listValueKey: "totalCount", defaultVisible: true },
      { key: "article", labelKey: "article", type: "text", path: "article", defaultVisible: false },
      { key: "saleUSD", labelKey: "price", type: "money", path: "saleUSD", align: "right", defaultVisible: false },
      { key: "count", labelKey: "quantity", type: "number", path: "totalCount", align: "right", primary: true, defaultVisible: true },
      { key: "totalPriceUSD", labelKey: "sum", type: "money", path: "totalPriceUSD", align: "right", defaultVisible: false },
    ],
  },
  {
    code: "purchases",
    labelKey: "purchase",
    permission: "purchases",
    url: "Purchases",
    createPath: "/purchases?purchase=add",
    fields: [
      { key: "datePurchase", labelKey: "date", type: "datetime", path: "datePurchase", primary: true, defaultVisible: true },
      { key: "factory", labelKey: "factory", type: "text", path: "mainFactory.name", primary: true, defaultVisible: true },
      { key: "warehouse", labelKey: "warehouse", type: "text", path: "mainWarehouse.name", defaultVisible: true },
      { key: "product", labelKey: "product", type: "text", path: "mainProduct.nameModel", defaultVisible: false },
      { key: "amount", labelKey: "quantity", type: "number", path: "amount", align: "right", defaultVisible: false },
      { key: "totalPriceUSD", labelKey: "sum", type: "money", path: "totalPriceUSD", align: "right", primary: true, defaultVisible: true },
    ],
    totalField: { path: "totalOutcome.totalPriceUSD", labelKey: "total", type: "money" },
  },
  {
    code: "wPurchases",
    labelKey: "wPurchases",
    permission: "wPurchases",
    url: "Purchases",
    fields: [
      { key: "datePurchase", labelKey: "date", type: "datetime", path: "datePurchase", primary: true, defaultVisible: true },
      { key: "document", labelKey: "document", type: "text", path: "document", defaultVisible: true },
      { key: "status", labelKey: "status", type: "status", path: "status", align: "center", defaultVisible: true },
      { key: "amount", labelKey: "quantity", type: "number", path: "amount", align: "right", primary: true, defaultVisible: true },
    ],
    totalField: { path: "totalOutcome.amount", labelKey: "total", type: "number" },
  },
  {
    code: "counterparties",
    labelKey: "counterparties",
    permission: "counterparties",
    url: "Counterparties",
    fields: [
      { key: "name", labelKey: "name", type: "text", path: "name", primary: true, defaultVisible: true },
      { key: "phone", labelKey: "phone", type: "text", path: "phone", defaultVisible: true },
      { key: "debt", labelKey: "debt", type: "money", path: "debt", align: "right", primary: true, defaultVisible: true },
    ],
  },
  {
    code: "products",
    labelKey: "goods",
    permission: "products",
    url: "Products",
    fields: [
      { key: "nameModel", labelKey: "name", type: "text", path: "nameModel", primary: true, defaultVisible: true },
      { key: "article", labelKey: "article", type: "text", path: "article", defaultVisible: true },
      { key: "salePriceUSD", labelKey: "price", type: "money", path: "salePriceUSD", align: "right", primary: true, defaultVisible: true },
      { key: "productCount", labelKey: "quantity", type: "number", path: "productCount", align: "right", defaultVisible: false },
    ],
  },
  {
    code: "returnSales",
    labelKey: "returnSale",
    permission: "returnSales",
    url: "ReturnSales",
    fields: [
      { key: "dateReturnSale", labelKey: "date", type: "datetime", path: "dateReturnSale", primary: true, defaultVisible: true },
      { key: "counterparty", labelKey: "counterparty", type: "text", path: "mainCounterparty.name", primary: true, defaultVisible: true },
      { key: "amount", labelKey: "quantity", type: "number", path: "amount", align: "right", primary: true, defaultVisible: true },
    ],
  },
  {
    code: "moneys",
    labelKey: "money",
    permission: "moneys",
    url: "Moneys",
    fields: [
      { key: "dateMoney", labelKey: "date", type: "datetime", path: "dateMoney", primary: true, defaultVisible: true },
      { key: "purpose", labelKey: "purpose", type: "text", path: "moneyPurposePayment.name", defaultVisible: true },
      { key: "amountUSD", labelKey: "sum", type: "money", path: "amountUSD", align: "right", primary: true, defaultVisible: true },
    ],
  },
  {
    code: "moneyReceipts",
    labelKey: "moneyReceipts",
    permission: "moneyReceipts",
    url: "MoneyReceipts",
    fields: [
      { key: "dateReceipt", labelKey: "date", type: "datetime", path: "dateReceipt", primary: true, defaultVisible: true },
      { key: "counterparty", labelKey: "counterparty", type: "text", path: "mainCounterparty.name", primary: true, defaultVisible: true },
      { key: "paymentType", labelKey: "paymentType", type: "text", path: "moneyPaymentType.name", defaultVisible: false },
      { key: "comment", labelKey: "comment", type: "text", path: "comment", defaultVisible: false },
      { key: "amount", labelKey: "sum", type: "money", path: "amount", align: "right", primary: true, defaultVisible: true },
    ],
  },
  {
    code: "wMoney",
    labelKey: "wMoney",
    permission: "wMoney",
    url: "wMoneys",
    fields: [
      { key: "dateMoney", labelKey: "date", type: "datetime", path: "dateMoney", primary: true, defaultVisible: true },
      { key: "purpose", labelKey: "purpose", type: "text", path: "moneyPurposePayment.name", defaultVisible: true },
      { key: "document", labelKey: "document", type: "text", path: "document", defaultVisible: false },
      { key: "reason", labelKey: "reason", type: "text", path: "reason", defaultVisible: false },
      { key: "amountUSD", labelKey: "sum", type: "money", path: "amountUSD", align: "right", primary: true, defaultVisible: true },
    ],
  },
  {
    code: "returnPurchases",
    labelKey: "returnPurchase",
    permission: "returnPurchases",
    url: "ReturnPurchases",
    fields: [
      { key: "dateReturnPurchase", labelKey: "date", type: "datetime", path: "dateReturnPurchase", primary: true, defaultVisible: true },
      { key: "factory", labelKey: "factory", type: "text", path: "mainFactory.name", primary: true, defaultVisible: true },
      { key: "product", labelKey: "product", type: "text", path: "mainProduct.nameModel", defaultVisible: false },
      { key: "document", labelKey: "document", type: "text", path: "document", defaultVisible: false },
      { key: "amount", labelKey: "quantity", type: "number", path: "amount", align: "right", defaultVisible: true },
      { key: "totalPriceUSD", labelKey: "sum", type: "money", path: "totalPriceUSD", align: "right", primary: true, defaultVisible: true },
    ],
    totalField: { path: "totalOutcome.totalPriceUSD", labelKey: "total", type: "money" },
  },
  {
    code: "warehouses",
    labelKey: "warehouses",
    permission: "warehouses",
    url: "Warehouses",
    fields: [
      { key: "name", labelKey: "name", type: "text", path: "name", primary: true, defaultVisible: true },
      { key: "address", labelKey: "address", type: "text", path: "address", defaultVisible: true },
    ],
  },
  {
    code: "factories",
    labelKey: "factories",
    permission: "factories",
    url: "Factories",
    fields: [
      { key: "name", labelKey: "name", type: "text", path: "name", primary: true, defaultVisible: true },
      { key: "phone", labelKey: "phone", type: "text", path: "phone", primary: true, defaultVisible: true },
      { key: "address", labelKey: "address", type: "text", path: "address", defaultVisible: false },
      { key: "email", labelKey: "email", type: "text", path: "email", defaultVisible: false },
    ],
  },
  {
    code: "showcases",
    labelKey: "showcases",
    permission: "showcases",
    url: "Showcases",
    fields: [
      { key: "dateShowcase", labelKey: "date", type: "datetime", path: "inserted", primary: true, defaultVisible: true },
      { key: "counterparty", labelKey: "counterparty", type: "text", path: "mainCounterparty.name", primary: true, defaultVisible: true },
      { key: "product", labelKey: "product", type: "text", path: "mainProduct.nameModel", defaultVisible: true },
      { key: "count", labelKey: "quantity", type: "number", path: "count", align: "right", primary: true, defaultVisible: true },
    ],
  },
  {
    code: "managers",
    labelKey: "managers",
    permission: "managers",
    url: "Managers",
    fields: [
      { key: "name", labelKey: "name", type: "text", path: "name", primary: true, defaultVisible: true },
      { key: "lastname", labelKey: "lastname", type: "text", path: "lastname", defaultVisible: true },
      { key: "phone", labelKey: "phone", type: "text", path: "phone", primary: true, defaultVisible: true },
      { key: "email", labelKey: "email", type: "text", path: "email", defaultVisible: false },
    ],
  },
  {
    code: "logistics",
    labelKey: "logistics",
    permission: "logistics",
    url: "Deliveries",
    fields: [
      { key: "deliveryNumber", labelKey: "document", type: "text", path: "deliveryNumber", primary: true, defaultVisible: true },
      { key: "counterpartyName", labelKey: "counterparty", type: "text", path: "counterpartyName", primary: true, defaultVisible: true },
      { key: "driverName", labelKey: "driver", type: "text", path: "driverName", defaultVisible: true },
      { key: "vehiclePlate", labelKey: "vehicle", type: "text", path: "vehiclePlate", defaultVisible: false },
      { key: "status", labelKey: "status", type: "status", path: "status", align: "center", defaultVisible: false },
      { key: "totalAmountUSD", labelKey: "sum", type: "money", path: "totalAmountUSD", align: "right", primary: true, defaultVisible: true },
    ],
  },
  {
    code: "auditLogs",
    labelKey: "auditLogs",
    permission: "auditLogs",
    url: "AuditLogs",
    fields: [
      { key: "createdAt", labelKey: "date", type: "datetime", path: "createdAt", primary: true, defaultVisible: true },
      { key: "userName", labelKey: "user", type: "text", path: "userName", primary: true, defaultVisible: true },
      { key: "entityName", labelKey: "section", type: "text", path: "entityName", defaultVisible: true },
      { key: "action", labelKey: "action", type: "text", path: "action", defaultVisible: true },
      { key: "changes", labelKey: "changes", type: "text", path: "changes", defaultVisible: false },
    ],
  },
]

export function findSection(code: string): MobileSection | undefined {
  return MOBILE_SECTIONS.find((s) => s.code === code)
}

/** Yozuvdan "a.b.c" yo'li bo'yicha qiymat olish */
export function readPath(row: any, path: string): any {
  if (!row || !path) return undefined
  return path.split(".").reduce((acc: any, key) => (acc == null ? acc : acc[key]), row)
}
